import React, { useCallback, useRef, useState } from 'react';
import { FiMail, FiLock, FiEye, FiEyeOff } from 'react-icons/fi';
import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';
import * as Yup from 'yup';

import Input from '../../components/Input';
import Button from '../../components/Button';

import * as S from './styles';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '../../hooks/auth';
// import getValidationErrors from '../../utils/getValidationErrors';
import { useToast } from '../../hooks/toast';
import api from '../../services/api';

interface SignInFormData {
  token: string;
  password: string;
  confirmPassword: string;
}

const RedefinirSenha: React.FC = () => {
  const { token } = useParams();
  const formRef = useRef<FormHandles>(null);
  const { addToast } = useToast();
  const [loading, setLoading] = useState(false);
  const [showpass, setShowPass] = useState(false);
  const showPassword = () => setShowPass(!showpass);
  let navigate = useNavigate();

  const handleSubmit = useCallback(
    async (data: SignInFormData) => {
      setShowPass(false);
      try {
        formRef.current?.setErrors({});

        const schema = Yup.object().shape({
          password: Yup.string(),
          confirmPassword: Yup.string(),
        });

        await schema.validate(data, {
          abortEarly: false,
        });

        setLoading(true);
        const password = data.password;
        const confirmPassword = data.confirmPassword;
        await api.post(`account/reset-password`, { token, password, confirmPassword }).then(() => {
          addToast({
            type: 'success',
            title: 'Senha alterada',
          });
          setLoading(false);
          navigate(`/`);
        });
      } catch (err: any) {
        setLoading(false);
        // const errors = getValidationErrors(err);
        // formRef.current?.setErrors(errors);
        console.log(err);
        let errMsg: string = '';
        if (err.response.data) {
          errMsg = err.response.data?.message;
        } else {
          errMsg = err.message;
        }
        addToast({
          type: 'error',
          title: errMsg,
        });
      }
    },
    [navigate, addToast]
  );

  return (
    <S.Container>
      <div>
        <div>
          <div>
            <div>
              <h1>
                Faça seu login <br />
                na plataforma
              </h1>
            </div>
            <Form
              ref={formRef}
              onSubmit={handleSubmit}
              placeholder={undefined}
              onPointerEnterCapture={undefined}
              onPointerLeaveCapture={undefined}
            >
              <section>
                <Input name="password" icon={FiLock} subicon={showpass ? FiEye : FiEyeOff}
                      type={showpass ? 'text' : 'password'} placeholder="Senha"
                      disabled={loading} handleclick={showPassword}
                    />
                <Input name="confirmPassword" icon={FiLock} subicon={showpass ? FiEye : FiEyeOff}
                      type={showpass ? 'text' : 'password'} placeholder="Confirme a senha"
                      disabled={loading} handleclick={showPassword}
                    />
                <Button loading={loading} type="submit">
                  Alterar
                </Button>
              </section>
            </Form>
          </div>
        </div>
      </div>
    </S.Container>
  );
};

export default RedefinirSenha;
